export enum TaskType {
  SIMPLE = 'SIMPLE_TASK',
  PAYMENT = 'PAYMENT_TASK',
  NOTE = 'NOTE',
  EVENT = 'EVENT'
}
